import React from 'react'

// Styled Components
import { Loader, LoaderFill } from './Loader.styles'

const LoaderComponent = () => (
    <Loader>
        <LoaderFill />
    </Loader>
)

export default LoaderComponent



// WEBPACK FOOTER //
// ./src/components/Loader.js